module.exports = __webpack_public_path__ + "static/media/asgard.ac3e0826.png";